import { render, staticRenderFns } from "./LoadingComp.vue?vue&type=template&id=4e6097b1&scoped=true&"
import script from "./LoadingComp.vue?vue&type=script&setup=true&lang=js&"
export * from "./LoadingComp.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./LoadingComp.vue?vue&type=style&index=0&id=4e6097b1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6097b1",
  null
  
)

export default component.exports